import { Message } from '../../store';
import { PlayerTutorialWindowState } from '../playerTutorial/playerTutorialWindowState';

// ---------------------------------------------------------------------------
// Tutorial highlighted components
// ---------------------------------------------------------------------------

export function isTutorialOnForChromeTop(
  highlightedComponents: string[] | undefined,
): boolean {
  return (highlightedComponents?.indexOf('TOOLS') ?? -1) >= 0;
}

export function isTutorialOnForReactions(
  highlightedComponents: string[] | undefined,
): boolean {
  return (highlightedComponents?.indexOf('REACTIONS') ?? -1) >= 0;
}

// ---------------------------------------------------------------------------
// Orientation change handler logic
// ---------------------------------------------------------------------------

export function getOrientationAction(ctx: {
  readonly isWidgetMode: boolean;
  readonly store: {
    readonly orientation: { getOrientationType(): string | null };
  };
}): 'enterFullscreen' | 'exitFullscreen' | null {
  const orientationType = ctx.store.orientation.getOrientationType();
  if (ctx.isWidgetMode || !orientationType)
    return null;

  if (['landscape-primary', 'landscape-secondary'].includes(orientationType))
    return 'enterFullscreen';

  if (['portrait-primary', 'portrait-secondary'].includes(orientationType))
    return 'exitFullscreen';

  return null;
}

// ---------------------------------------------------------------------------
// Tutorial window listener logic
// ---------------------------------------------------------------------------

export function handleTutorialWindowMessage(
  msg: Message<PlayerTutorialWindowState>,
): boolean | null {
  switch (msg.type) {
    case 'open':
      return true;
    case 'close':
      return false;
    default:
      return null;
  }
}
